import { MyHttpClient } from '../../http-client.service';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../../http-client.service";
var GuestTripRouteDetailsService = /** @class */ (function () {
    function GuestTripRouteDetailsService(http) {
        this.http = http;
        this.server = "" + environment.server;
        this.tripRouteRequestDetails = this.server + '/api/getPoolTripRequestDetails';
    }
    GuestTripRouteDetailsService.prototype.getTripRouteRequestDetails = function (id) {
        return this.http.get(this.tripRouteRequestDetails + '/' + id).pipe(catchError(this.handleError));
    };
    GuestTripRouteDetailsService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        // return an observable with a user-facing error message
        return throwError(error);
    };
    GuestTripRouteDetailsService.ngInjectableDef = i0.defineInjectable({ factory: function GuestTripRouteDetailsService_Factory() { return new GuestTripRouteDetailsService(i0.inject(i1.MyHttpClient)); }, token: GuestTripRouteDetailsService, providedIn: "root" });
    return GuestTripRouteDetailsService;
}());
export { GuestTripRouteDetailsService };
